import React from 'react';
import { Box } from '@mui/material/';

export default function InvalidPromt() {
    return (
        <Box style={{
            color: 'red',
            fontSize: '1.2em',
            fontWeight: 'bold',
            marginBottom: 7
        }}>
            Invalid Room Number
        </Box >
    )
};